const includes = (arr, val) => arr.some(arrVal => val === arrVal);
export default includes;
//# sourceMappingURL=includes.js.map